import { useLanguage } from '../i18n/LanguageContext';

interface AccessDeniedProps {
  onLogout: () => void;
}

function AccessDenied({ onLogout }: AccessDeniedProps) {
  const { t } = useLanguage();

  return (
    <div className="form-container" style={{ textAlign: 'center', marginTop: '4rem', position: 'relative' }}>
      <h2 style={{ color: '#dc3545', marginBottom: '1rem' }}>{t('auth.accessDenied')}</h2>
      <p style={{ color: '#666', marginBottom: '2rem' }}>
        {t('auth.accessDenied.message')}
      </p>
      <button
        onClick={onLogout}
        className="btn btn-primary"
        style={{ padding: '0.75rem 2rem' }}
      >
        {t('nav.logout')}
      </button>
    </div>
  );
}

export default AccessDenied;
